import { create } from "zustand";

type Language = "en" | "am";

const STORAGE_KEY = "sartn_language";

function loadSavedLanguage(): Language {
  if (typeof window === "undefined") return "en";

  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === "am" || saved === "en") return saved;

  return "en";
}

interface LanguageState {
  language: Language;
  setLanguage: (language: Language) => void;
  toggleLanguage: () => void;
}

export const useLanguageStore = create<LanguageState>((set) => ({
  language: loadSavedLanguage(),

  setLanguage: (language) => {
    localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.setAttribute("lang", language);
    set({ language });
  },

  toggleLanguage: () =>
    set((state) => {
      const nextLanguage: Language = state.language === "en" ? "am" : "en";
      localStorage.setItem(STORAGE_KEY, nextLanguage);
      document.documentElement.setAttribute("lang", nextLanguage);
      return { language: nextLanguage };
    }),
}));

export type { Language };
